import { useMemo } from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { NationalFlag, RiderName } from '../Pick/ui'
import { TeamJersey } from '../RiderFace'

// Una riga di corridore scelto, come nella scheda giocatore del Pick: slot, maglia della squadra, bandiera, nome.
// Usata dalle schede della Classifica (giocatore e squadra). `tags` va sotto il nome, `right` a destra (piazzamento, punti).
export default function RiderRow({ slot, rd, national, name, tags, right, highlight = false, dim = false }) {
  const tc = useThemeColors()
  const s = useMemo(() => makeStyles(), [])
  return (
    <View style={[s.row, { backgroundColor: tc.bgCard2, borderColor: highlight ? tc.rosaBorder : tc.border }, dim && { opacity: 0.6 }]}>
      <View style={[s.slot, { backgroundColor: tc.bgCard3 }]}>
        <Text style={[s.slotText, { color: tc.textMuted }]}>{slot}</Text>
      </View>
      {!national && rd ? <TeamJersey kit={rd.kit} size={44} /> : null}
      {rd?.id_national ? <NationalFlag code={rd.id_national} /> : null}
      <View style={{ flex: 1, minWidth: 0 }}>
        <RiderName name={name} style={[s.rider, { color: tc.text }]} />
        {tags}
      </View>
      {right}
    </View>
  )
}

const makeStyles = () => StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 10, borderWidth: 1, borderRadius: 12, padding: 10, minHeight: 56 },
  slot: { width: 26, height: 26, borderRadius: 13, alignItems: 'center', justifyContent: 'center' },
  slotText: { fontFamily: fonts.condensedBold, fontSize: 13 },
  rider: { fontSize: 15 },
})
